<template>
  <div
   :aria-hidden="data.hidden"
    class="fit-dialog"
    :class="[
      { 'fit-dialog-vertical': isValignBtn, 'fit-dialog-weui': data.weui, 'show-dlg': !data.hidden },
      data.theme,
    ]"
    v-on:click="onLayerClick"
    v-on:touchmove.prevent
  >
    <div class="flex-center">
      <div class="dlg-main" v-on:click.stop>
        <div class="dlg-bar" v-if="data.closeBtn">
          <i v-on:click="onClose" class="dlg-icon-close"></i>
        </div>
        <div class="dlg-content flex-v flex-center" :class="{ noBorder: data.btns.length <= 0 }">
          <div class="dlg-title" v-if="data.title">{{ data.title }}</div>
          <div class="dlg-text">
            <div v-if="this.$slots.default">
              <slot></slot>
            </div>
            <div v-else-if="data.htmlContent" v-html="data.htmlContent"></div>
            <div class="plain-text" v-else>{{ data.content }}</div>
          </div>
        </div>
        <div v-if="data.btns.length > 0" class="dlg-btns flex" :class="{ onlyBtn: data.btns.length == 1 }">
          <button v-for="(btn, index) in data.btns" v-on:click="bindTap(btn)" :key="'btn' + index" class="flex-1">
            {{ btn.text }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fit-dialog',
  props: {
    title: {
      type: String,
      default: '',
    },
    htmlContent: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
    btns: {
      type: Array,
      default() {
        return [];
      },
    },
    weui: {
      type: Boolean,
      default: false,
    },
    valignBtn: {
      type: Boolean,
      default: false,
    },
    closeBtn: {
      type: Boolean,
      default: false,
    },
    autoClose: {
      type: Boolean,
      default: false,
    },
    hidden: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      data: {
        title: this.title,
        htmlContent: this.htmlContent,
        content: this.content,
        theme: this.theme,
        btns: this.btns || [],
        weui: this.weui,
        valignBtn: this.valignBtn,
        closeBtn: this.closeBtn,
        autoClose: this.autoClose,
        hidden: this.hidden,
      },
    };
  },
  computed: {
    isValignBtn() {
      let btn = null;
      if (this.data.valignBtn) {
        return this.data.valignBtn;
      }
      if (this.data.btns && this.data.btns.length > 2) {
        return true;
      }
      if (this.data.btns && this.data.btns.length === 2) {
        for (let i = this.data.btns.length - 1; i >= 0; i--) {
          btn = this.data.btns[i];
          if (btn && btn.text && btn.text.length > 14) {
            return true;
          }
        }
      }
      return false;
    },
    isHidden: {
      get() {
        return this.data.hidden;
      },
      set(value) {
        this.data.hidden = value;
        this.$emit('input', value);
      },
    },
  },
  watch: {
    title() {
      this.data.title = this.title;
    },
    htmlContent() {
      this.data.htmlContent = this.htmlContent;
    },
    content() {
      this.data.content = this.content;
    },
    theme() {
      this.data.theme = this.theme;
    },
    btns() {
      this.data.btns = this.btns || [];
    },
    weui() {
      this.data.weui = this.weui;
    },
    valignBtn() {
      this.data.valignBtn = this.valignBtn;
    },
    closeBtn() {
      this.data.closeBtn = this.closeBtn;
    },
    autoClose() {
      this.data.autoClose = this.autoClose;
    },
    hidden() {
      this.data.hidden = this.hidden;
    },
  },
  methods: {
    bindTap(btn) {
      if (btn && typeof btn.click === 'function') {
        btn.click();
      } else {
        this.hide();
      }
    },
    show(args) {
      if (sessionStorage.getItem('loggingIn') === '1') {
        return;
      }
      const self = this;
      if (args) {
        Object.keys(this.data).forEach((key) => {
          if (args.hasOwnProperty(key) && typeof this.data[key] === typeof args[key]) {
            this.data[key] = args[key];
          } else {
            const prop = this.$options.props[key];
            if (prop) {
              let defValue = prop.default;
              if ((prop.type === Object || prop.type === Array) && typeof defValue === 'function') {
                defValue = defValue.call(self);
              }
              this.data[key] = defValue;
            }
          }
        });
      }
      this.isHidden = false;
    },
    hide() {
      this.isHidden = true;
    },
    onClose() {
      this.hide();
    },
    onLayerClick(e) {
      if (this.data.autoClose) {
        this.hide();
      }
    },
  },
};
</script>

<style lang="less" scoped>
@rem: 200rem;

.fit-dialog {
  position: fixed;
  display: none;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  font-size: 32/@rem;
  line-height: 1;
  z-index: 999;
}
.fit-dialog.show-dlg {
  display: block;
}
.fit-dialog .dlg-main {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 540/@rem;
  background-color: #e7e7e7;
  border-radius: 24/@rem;
  overflow: hidden;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.fit-dialog .dlg-title {
  padding-bottom: 18/@rem;
  font-weight: bold;
}
.fit-dialog .dlg-content {
  position: relative;
  text-align: center;
  padding: 30/@rem 40/@rem;
  line-height: 46/@rem;
  min-height: 40/@rem;
  color: #000;
}
.fit-dialog .dlg-text {
  text-align: center;
}
.fit-dialog .dlg-text .plain-text {
  display: inline-block;
  text-align: center;
}
.fit-dialog .dlg-content img {
  max-width: 488/@rem;
}
.fit-dialog .dlg-content:after {
  position: absolute;
  content: '';
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
  color: #bababa;
  border-top: 1px solid #bababa;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.fit-dialog .dlg-content.noBorder:after {
  border-top: none;
}
.fit-dialog .dlg-btns button {
  position: relative;
  height: 88/@rem;
  color: #0076ff;
  font-size: 34/@rem;
  background: #e7e7e7;
}
.fit-dialog .dlg-btns button:active {
  background: rgba(0, 0, 0, 0.1);
}
.fit-dialog .dlg-btns button:nth-child(2):before {
  position: absolute;
  content: '';
  top: 0;
  bottom: 0;
  left: 0;
  width: 0;
  color: #bababa;
  border-left: 1px solid #bababa;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleX(0.5);
  transform: scaleX(0.5);
}
.fit-dialog button {
  cursor: pointer;
  border: none;
}
.fit-dialog .dlg-bar {
  position: absolute;
  right: 0;
  top: 4/@rem;
  z-index: 1;
  font-size: 40/@rem;
  width: 80/@rem;
  text-align: center;
}

.fit-dialog .dlg-icon-close:before,
.dlg-icon-close:after {
  content: '';
  position: absolute;
  width: 40%;
  height: 1px;
  background-color: #333;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.fit-dialog .dlg-icon-close:before {
  -webkit-transform: rotateZ(45deg);
  transform: rotateZ(45deg);
}
.fit-dialog .dlg-icon-close {
  position: relative;
  width: 60/@rem;
  height: 60/@rem;
  display: inline-block;
}
.fit-dialog .dlg-icon-close:after {
  -webkit-transform: rotateZ(-45deg);
  transform: rotateZ(-45deg);
}

.fit-dialog-vertical .dlg-btns {
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  flex-direction: column;
}
.fit-dialog-vertical .dlg-btns button:after {
  position: absolute;
  content: '';
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
  color: #bababa;
  border-top: 1px solid #bababa;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.fit-dialog-vertical .dlg-btns button:last-child:after {
  content: none;
}

.fit-dialog-weui .dlg-main {
  width: 560/@rem;
  background-color: #fefefe;
  border-radius: 8/@rem;
}
.fit-dialog-weui .dlg-title {
  padding-bottom: 18/@rem;
}
.fit-dialog-weui .dlg-content {
  color: #353535;
  padding: 48/@rem 40/@rem 30/@rem 40/@rem;
  line-height: 44/@rem;
}
.fit-dialog-weui .dlg-title + .dlg-text {
  color: #888;
}
.fit-dialog-weui .dlg-content:after {
  border-color: #e4e4e4;
}
.fit-dialog-weui .dlg-btns button {
  height: 100/@rem;
  line-height: 100/@rem;
  color: #000000;
  background: #fefefe;
}
.fit-dialog-weui .dlg-btns button:last-child {
  color: #02bb00;
}
.fit-dialog-weui .dlg-btns button:nth-child(2):before {
  border-color: #e4e4e4;
}
.fit-dialog-weui button {
  cursor: pointer;
  border: none;
}

.fit-dialog-weui .dlg-bar {
  position: absolute;
  right: 0;
  top: 4/@rem;
  z-index: 1;
  font-size: 40/@rem;
  width: 80/@rem;
  text-align: center;
}
.fit-dialog-weui .dlg-icon-close:before,
.dlg-icon-close:after {
  content: '';
  position: absolute;
  width: 40%;
  height: 1px;
  background-color: #333;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.fit-dialog-weui .dlg-icon-close:before {
  -webkit-transform: rotateZ(45deg);
  transform: rotateZ(45deg);
}
.fit-dialog-weui .dlg-icon-close {
  position: relative;
  width: 60/@rem;
  height: 60/@rem;
  display: inline-block;
}
.fit-dialog-weui .dlg-icon-close:after {
  -webkit-transform: rotateZ(-45deg);
  transform: rotateZ(-45deg);
}

.fit-dialog-green .dlg-main {
  width: auto;
  min-width: 640/@rem;
  background-color: #fefefe;
  border-radius: 24/@rem;
  margin-top: -60/@rem;
  overflow: initial;
}
.fit-dialog-green .dlg-title {
  padding-bottom: 30/@rem;
}
.fit-dialog-green .dlg-content {
  color: #353535;
  padding: 47/@rem 36/@rem 35/@rem;
  line-height: 44/@rem;
}
.fit-dialog-green .dlg-title + .dlg-text {
  width: 100%;
  color: #888;
}
.fit-dialog-green .dlg-content:after {
  border: none;
}
.fit-dialog-green .dlg-btns {
  justify-content: center;
}
.fit-dialog-green .dlg-btns button {
  color: #23b75e;
  font-size: 34/@rem;
  text-align: center;
  line-height: 80/@rem;
  width: 200/@rem;
  height: 80/@rem;
  border-radius: 8/@rem;
  background-color: #f2f2f2;
  margin: 0 31/@rem 35/@rem 0;
}
.fit-dialog-green .dlg-btns button:last-child {
  background-color: #23b75e;
  color: #fff;
  margin-right: 0;
}
.fit-dialog-green .dlg-btns button:before {
  border: none;
}
.fit-dialog-green .dlg-btns button:after {
  border: none;
}
.fit-dialog-green .dlg-btns button:nth-child(2):before {
  border: none;
}
.fit-dialog-green .dlg-btns.onlyBtn button {
  width: 390/@rem;
}
.fit-dialog-green button {
  cursor: pointer;
  border: none;
}
.fit-dialog-green .dlg-btns button.flex-1 {
  flex: none;
}

.fit-dialog-green .dlg-bar {
  position: absolute;
  right: 50%;
  top: 100%;
  margin-top: 60/@rem;
  margin-right: -40/@rem;
  z-index: 1;
  font-size: 40/@rem;
  width: 80/@rem;
  text-align: center;
  align-items: center;
}
.fit-dialog-green .dlg-icon-close:before,
.dlg-icon-close:after {
  content: '';
  position: absolute;
  width: 40%;
  height: 1px;
  background-color: #fff;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.fit-dialog-green .dlg-icon-close:before {
  -webkit-transform: rotateZ(45deg);
  transform: rotateZ(45deg);
}
.fit-dialog-green .dlg-icon-close {
  position: relative;
  width: 60/@rem;
  height: 60/@rem;
  display: inline-block;
  border: 1px solid #fff;
  border-radius: 60/@rem;
}
.fit-dialog-green .dlg-icon-close:after {
  -webkit-transform: rotateZ(-45deg);
  transform: rotateZ(-45deg);
}

.fit-dialog-img .dlg-main {
  width: auto;
  background-color: transparent;
  overflow: initial;
}

.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.flex-1 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

@media (width: 640/@rem) {
  .fit-dialog-green .dlg-main {
    min-width: 544/@rem;
  }
}
</style>
